import axios from "axios";
import { IP } from "../index";
// 查询所有人工录入检测数据
export async function selectApi(data) {
  var resp = await axios.post(`${IP}/admin/handResult/select`, {
    ...data,
  });
  return resp.data;
}

// 删除人工录入检测数据
export async function deleteApi(data) {
  var resp = await axios.post(`${IP}/admin/handResult/delete`, {
    ...data,
  });
  return resp.data;
}

// 新增或修改人工录入检测数据
export async function addApi(data) {
  var resp = await axios.post(`${IP}/admin/handResult/add`, {
    ...data,
  });
  return resp.data;
}

